import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-video-container">
          <video
            className="hero-video"
            autoPlay
            muted
            loop
            playsInline
            poster="/videos/hero-fallback.jpg"
          >
            <source src="/videos/hero-video.mp4" type="video/mp4" />
            {/* Fallback for browsers that don't support video */}
            Your browser does not support the video tag.
          </video>
          <div className="hero-video-overlay"></div>
        </div>
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">
              Transforming Industrial Emissions into 
              <span className="highlight"> Clean Solutions</span>
            </h1>
            <p className="hero-subtitle">
              We combine cutting-edge CO₂ filtration technology with proven oil & gas expertise 
              to capture, compress, and permanently store carbon emissions deep underground.
            </p>
            <div className="hero-actions">
              <Link to="/contact" className="btn btn-primary">
                Get Started Today
              </Link>
              <Link to="/what-we-do" className="btn btn-secondary">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Technology Process Section */}
      <section className="section process-section">
        <div className="container">
          <h2 className="section-title">Our Carbon Capture Process</h2>
          <p className="section-subtitle">
            A proven, integrated approach to industrial decarbonization
          </p>
          
          <div className="process-grid">
            <div className="process-step">
              <div className="step-number">01</div>
              <h3>Capture</h3>
              <p>
                Advanced filtration systems extract CO₂ directly from industrial flue gas 
                using state-of-the-art separation technology.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">02</div>
              <h3>Compress</h3>
              <p>
                High-efficiency compression systems prepare captured CO₂ for safe 
                transportation and long-term storage.
              </p>
            </div>
            
            <div className="process-step">
              <div className="step-number">03</div>
              <h3>Store</h3>
              <p>
                Permanent geological storage in deep underground formations, 
                leveraging decades of oil & gas industry expertise.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Value Proposition Section */}
      <section className="section value-section">
        <div className="container">
          <div className="value-content">
            <div className="value-text">
              <h2>Why Choose Sequester?</h2>
              <div className="value-points">
                <div className="value-point">
                  <div>
                    <h4>Proven Technology</h4>
                    <p>Battle-tested CO₂ capture and storage solutions with industry-leading efficiency rates.</p>
                  </div>
                </div>
                
                <div className="value-point">
                  <div>
                    <h4>Oil & Gas Expertise</h4>
                    <p>Decades of experience in subsurface operations and geological storage management.</p>
                  </div>
                </div>
                
                <div className="value-point">
                  <div>
                    <h4>End-to-End Solutions</h4>
                    <p>Complete project lifecycle management from development to long-term operations.</p>
                  </div>
                </div>
                
                <div className="value-point">
                  <div>
                    <h4>Regulatory Compliance</h4>
                    <p>Full compliance with environmental regulations and carbon credit programs.</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="value-visual">
              <div className="stats-grid">
                <div className="stat">
                  <div className="stat-number">95%</div>
                  <div className="stat-label">CO₂ Capture Rate</div>
                </div>
                <div className="stat">
                  <div className="stat-number">1000+</div>
                  <div className="stat-label">Years Storage Security</div>
                </div>
                <div className="stat">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Monitoring & Support</div>
                </div>
                <div className="stat">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Regulatory Compliance</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Industries Section */}
      <section className="section industries-section">
        <div className="container">
          <h2 className="section-title">Industries We Serve</h2>
          <p className="section-subtitle">
            Tailored carbon capture solutions for high-emission industrial sectors
          </p>
          
          <div className="industries-grid">
            <div className="industry-card">
              <h3>Steel & Metals</h3>
              <p>Reducing emissions from steel production and metal processing facilities.</p>
            </div>
            
            <div className="industry-card">
              <h3>Cement</h3>
              <p>Capturing process emissions from cement manufacturing operations.</p>
            </div>
            
            <div className="industry-card">
              <h3>Power Generation</h3>
              <p>Retrofitting existing power plants with advanced capture technology.</p>
            </div>
            
            <div className="industry-card">
              <h3>Chemicals</h3>
              <p>Decarbonizing petrochemical and chemical processing facilities.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section cta-section">
        <img 
          src="/images/cta-background.avif" 
          alt="Industrial facility background" 
          className="cta-background-img"
        />
        <div className="cta-overlay"></div>
        <div className="container">
          <div className="cta-content">
            <h2>Ready to Decarbonize Your Operations?</h2>
            <p>
              Join leading industrial companies in the transition to net-zero emissions. 
              Our experts are ready to develop a custom carbon capture solution for your facility.
            </p>
            <div className="cta-actions">
              <Link to="/contact" className="btn btn-primary">
                Schedule Consultation
              </Link>
              <Link to="/what-we-do" className="btn btn-secondary">
                Explore Our Services
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home; 